import React from 'react';

const AboutPage = () => {
    return (
        <div>This is the About Page!</div>
    )
}

export default AboutPage;